// Insert analyses data router
export default [
  {
    path: 'analyses-data',
    name: 'insertAnalysesData',
    redirect: 'analyses-data/index',
    component: () =>
      import(
        /* webpackChunkName: "insertAnalysesData" */ '../views/analysesData/InsertAnalysesData.vue'
      ),
    children: [
      {
        path: 'index',
        name: 'insertAnalysesDataIndex',
        meta: {
          tabbable: true,
          tableKeys: ['insertAnalysesData'],
          filterKeys: ['insertAnalysesData'],
          formKeys: [],
          routePermissions: ['analysesDataView'],
        },
        component: () =>
          import(
            /* webpackChunkName: "insertAnalysesDataIndex" */ '../views/analysesData/InsertAnalysesDataIndex.vue'
          ),
      },
    ],
  },
];
